import CryptoJS from 'crypto-js'

const ENCRYPTION_KEY = process.env.REACT_APP_REACT_APP_ENCRYPTION_KEY || 'default_key'

function JWTtDecode(token: string) {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')

    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join(''),
    )
    return JSON.parse(jsonPayload)
}

export const IsValidToken = (accessToken: string) => {
    if (!accessToken) {
        return false
    }

    const decoded = JWTtDecode(accessToken)

    const currentTime = Date.now() / 1000

    return decoded.exp > currentTime
}

// Encrypt function
export const Encrypt = (value: string | null): string | null => {

    if (!value) return null
    return CryptoJS.AES.encrypt(value, ENCRYPTION_KEY).toString()
}

// Decrypt function
export const Decrypt = (encryptedValue: string | null): string | null => {

    if (!encryptedValue) return null
    const bytes = CryptoJS.AES.decrypt(encryptedValue, ENCRYPTION_KEY)
    return bytes.toString(CryptoJS.enc.Utf8)
}

export const VerifyDateCondition = (encryptedDate: string | null, comparisonDate: string | null): boolean => {

    if (!encryptedDate) {
        // console.error('Encrypted date is null or undefined')
        return false
    }

    const decryptedDate = Decrypt(encryptedDate)

    // Ensure the decryptedDate is valid
    if (!decryptedDate || !comparisonDate) {
        console.error('Decrypted date or comparison date is invalid', {decryptedDate, comparisonDate})
        return false
    }

    // Convert the strings to Date objects
    const decryptedDateObj = new Date(decryptedDate)
    const comparisonDateObj = new Date(comparisonDate)

    // Ensure both dates are valid
    if (isNaN(decryptedDateObj.getTime()) || isNaN(comparisonDateObj.getTime())) {
        console.error('Invalid Date objects created', {decryptedDate, comparisonDate})
        return false
    }

    return decryptedDateObj.getTime() === comparisonDateObj.getTime()
}
